var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-loading"},[_c('div',{staticClass:"loading"},[_c('span',{staticClass:"loading inner"})])])
}]

export { render, staticRenderFns }